"use client";

import {
  faCircleCheck,
  faShield,
  faTriangleExclamation,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import { useField } from "formik";

import {
  PASSWORD_STRENGTH_AVERAGE,
  PASSWORD_STRENGTH_GOOD,
  PASSWORD_STRENGTH_LABEL,
  PASSWORD_STRENGTH_NONE,
  PASSWORD_STRENGTH_WEAK,
} from "@shared/constants";

import getPasswordStrength from "@client/components/auth-form/functions/getPasswordStrength";

const strengthStyles = {
  [PASSWORD_STRENGTH_NONE]: {
    className: "text-orange-600",
    icon: undefined,
  },
  [PASSWORD_STRENGTH_WEAK]: {
    className: "text-orange-600",
    icon: faTriangleExclamation,
  },
  [PASSWORD_STRENGTH_AVERAGE]: {
    className: "text-green-600",
    icon: faCircleCheck,
  },
  [PASSWORD_STRENGTH_GOOD]: {
    className: "text-green-600",
    icon: faShield,
  },
};

interface Props {
  name: string;
}

export default function PasswordStrength({ name }: Props) {
  const [field] = useField<string>(name);

  const strength = getPasswordStrength(field.value || "");
  const { className, icon } = strengthStyles[strength];

  return (
    <p
      className="flex gap-1 items-center text-neutral-900 text-xs"
      data-spec="password-strength"
    >
      {PASSWORD_STRENGTH_LABEL}
      <span className={clsx("flex gap-1 items-center", className)}>
        {icon && <FontAwesomeIcon className="text-sm" icon={icon} />}
        {strength}
      </span>
    </p>
  );
}
